// Module
var code = "<article class=\"sw-color-card\" ng-class=\"$ctrl.getClass($ctrl.color)\"> <a href=\"{{ $ctrl.url }}\"> <sw-font-awesome ng-if=\"$ctrl.icon\" icon=\"$ctrl.icon\"></sw-font-awesome> {{ $ctrl.name }} </a> </article> ";
// Exports
export default code;